import { createTheme } from "@mui/material/styles";
import { designTokens } from "./tokens";

export const attendanceHeatmapTheme = createTheme({
  palette: {
    primary: {
      main: designTokens.accent,
      dark: designTokens.accentHover,
      contrastText: "#FFFFFF",
    },
    background: {
      default: designTokens.bgPage,
      paper: designTokens.bgCard,
    },
    text: {
      primary: designTokens.textPrimary,
      secondary: designTokens.textSecondary,
    },
    info: {
      main: designTokens.info,
    },
  },
  shape: {
    borderRadius: designTokens.radiusInput,
  },
  typography: {
    fontFamily: designTokens.fontFamily,
    body1: { fontSize: 14 },
    body2: { fontSize: 13 },
    button: { fontSize: 13, fontWeight: 600, textTransform: "none" },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: designTokens.radiusCard,
          backgroundImage: "none",
          boxShadow: designTokens.shadow,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 36,
          borderRadius: designTokens.radiusInput,
          boxShadow: "none",
        },
        containedPrimary: {
          "&:hover": {
            backgroundColor: designTokens.accentHover,
            boxShadow: "none",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          height: 36,
          borderRadius: designTokens.radiusInput,
          fontSize: 13,
        },
        notchedOutline: {
          borderColor: designTokens.border,
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: designTokens.accent,
            "&:hover, &:focus": {
              backgroundColor: designTokens.accentHover,
            },
          },
        },
      },
    },
  },
});

export const attendanceHeatmapCssVariables = {
  "--heat-bg-page": designTokens.bgPage,
  "--heat-bg-card": designTokens.bgCard,
  "--heat-bg-overlay": designTokens.bgOverlay,
  "--heat-border": designTokens.border,
  "--heat-text-primary": designTokens.textPrimary,
  "--heat-text-secondary": designTokens.textSecondary,
  "--heat-accent": designTokens.accent,
  "--heat-accent-hover": designTokens.accentHover,
  "--heat-info": designTokens.info,
  "--heat-radius-input": `${designTokens.radiusInput}px`,
  "--heat-radius-card": `${designTokens.radiusCard}px`,
  "--heat-shadow": designTokens.shadow,
  "--heat-floating-shadow": designTokens.floatingShadow,
  "--heat-font": designTokens.fontFamily,
};
